<template>
  <div class="h-100">
    <div class="content-page p-3 pb-5 h-100">
      <div class="row">
        <div
          class="col-2 text-left flex"
          v-if="hasRight(Settings.Permission.Change) && hasRight('AlwWrite')"
        >
        <div class="d-flex">
          <b-form-select
            name="shift"
            v-model="selectedYear"
            size="sm"
            v-on:change="handleYearChange"
            style="width: 300px;"
          >
            <option value="" selected
              >--- {{ t.t(dictEnum.LBL_Year) }} ---</option
            >
            <option
              v-for="( Yearday,  YearIndex) in YearType"
              :key="YearIndex"
              :value="Yearday.label"
            >
              {{ Yearday.value }}
            </option>
          </b-form-select>
          <b-form-select
            name="shift"
            v-model="selectedType"
            size="sm"
            v-on:change="handleTypeChange"
            style="width: 400px;margin-left:20px;"
          >
            <option value="" selected
              >--- {{ t.t(dictEnum.LBL_Type) }} ---</option
            >
            <option
              v-for="(holiday, holidayIndex) in Settings.HolidayType"
              :key="holidayIndex"
              :value="holiday.value"
            >
              {{ holiday.label }}
            </option>
            <!-- <option value="LABOR,BANK">{{ t.t(dictEnum.LBL_HolidayTypeALL) }}</option> -->
          </b-form-select>
        </div>
        </div>
        <div
          class="col-10 text-right"
          v-if="hasRight(Settings.Permission.Change) && hasRight('AlwWrite')"
        >
          <button class="btn btn-info" @click="clickSyncfromGov" :disabled="EditH">
            {{ `${this.t.t(dictEnum.LBL_SyncfromGov)} ` }}
          </button>
          <button
            class="btn btn-info"
            @click="initHoliday"
            v-b-modal.modal-holiday
            :disabled="EditH"
          >
            {{ `${this.t.t(dictEnum.LBL_Add)} ` }}
          </button>
          <!-- <button
            class="btn btn-info"
            @click="EditHoliday"
            :disabled="EditH"
          >
            {{ `${this.t.t(dictEnum.LBL_Edit)} ` }}
          </button> -->
          <button
           v-if="EditH"
            class="btn btn-info"
            @click="SaveHoliday"
          >
            {{ `${this.t.t(dictEnum.BTN_Save)} ` }}
          </button>
          <button
           v-if="EditH"
            class="btn btn-info"
            @click="CancelHoliday"
          >
            {{ `${this.t.t(dictEnum.BTN_Cancel)} ` }}
          </button>
        </div>
      </div>
      <div class="row h-100">
        <div class="col-sm-12 h-100 pb-5">
          <div class="tab-content  bg-white h-100">
            <div class="tab-pane active table-responsive color-table h-80">
              <b-table
                :items="tableData"
                :fields="tableFields"
                :current-page="currentPage"
                :per-page="15"
                sort-by="DateHoliday"
                sort-desc
              >
                <template #cell(HolidayType)="data">
                  <template v-if="EditH">
                    <b-form-select v-model="data.item.HolidayType" >
                      <option
                      v-for="(holiday, holidayIndex) in Settings.HolidayType"
                      :key="holidayIndex"
                      :value="holiday.value"
                      >
                      {{ holiday.label }}
                    </option>
                    <!-- <option value="LABOR,BANK">{{ t.t(dictEnum.LBL_HolidayTypeALL) }}</option> -->
                  </b-form-select>
                </template>
                <template v-else>
                  {{ TypeName(data.item.HolidayType) }}
                </template>
                </template>
                <template #cell(HolidayDesc)="data">
                  <template v-if="EditH">
                    <b-form-input v-model="data.item.HolidayDesc"></b-form-input>
                  </template>
                  <template v-else>
                    {{ data.item.HolidayDesc }}
                  </template>
                </template>
                <template #cell(Action)="data">
                  <font-awesome-icon
                    icon="edit"
                    style="cursor:pointer"
                    v-if="hasRight(Settings.Permission.Change)&&!EditH"
                    v-b-modal.modal-holiday
                    @click="editHoliday(data.item)"
                  />

                  <font-awesome-icon
                    icon="trash"
                    style="cursor:pointer"
                    v-if="hasRight('AlwDel')"
                    @click="deleteHoliday(data.item)"
                  />
                </template>
              </b-table>
            </div>
            <b-row no-gutters class="pt-3" v-if="tableData.length > 0">
              <b-col cols="2">
                <b-pagination
                  first-number
                  last-number
                  limit="10"
                  v-model="currentPage"
                  :per-page="15"
                  :total-rows="tableData.length"
                ></b-pagination>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="modal-holiday"
      :title="mode == 'new' ? t.t(dictEnum.LBL_Add) : t.t(dictEnum.BTN_Update)"
      :ok-title="t.t(dictEnum.BTN_Submit)"
      :cancel-title="t.t(dictEnum.BTN_Cancel)"
      @ok="editOrAddHoliday"
    >
      <div class="p-3">
        <b-row class="my-1 no-gutters">
          <b-col sm="5">
            <b-input-group-prepend is-text>
              <span class="bg-white">{{ t.t(dictEnum.MENU_Holiday) }}</span>
            </b-input-group-prepend>
          </b-col>
          <b-col sm="7">
            <b-form-group class="font-weight-normal">
              <date-picker
                id="dpHoliday"
                :placeholder="this.t.t(dictEnum.MENU_Holiday)"
                v-model="holiday.DateHoliday"
                :lang="lang"
                type="date"
                format="YYYY-MM-DD"
                :disabled="mode == 'new' ? false : true"
                v-bind:clearable="false"
              ></date-picker>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="my-1 no-gutters">
          <b-col sm="5">
            <b-input-group-prepend is-text>
              <span class="bg-white">{{ t.t(dictEnum.LBL_Description) }}</span>
            </b-input-group-prepend>
          </b-col>
          <b-col sm="7">
            <b-form-group class="font-weight-normal">
              <b-form-input
                maxlength="100"
                v-model="holiday.HolidayDesc"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="my-1 no-gutters">
          <b-col sm="5">
            <b-input-group-prepend is-text>
              <span class="bg-white">{{ t.t(dictEnum.LBL_Type) }}</span>
            </b-input-group-prepend>
          </b-col>
          <b-col sm="7">
            <b-form-select name="shift" v-model="holiday.HolidayType" size="sm">
              <option
                v-for="(holiday, holidayIndex) in Settings.HolidayType"
                :key="holidayIndex"
                :value="holiday.value"
              >
                {{ holiday.label }}
              </option>
              <!-- <option value="LABOR,BANK">{{ t.t(dictEnum.LBL_HolidayTypeALL) }}</option> -->
            </b-form-select>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
import MenuRightSerivce from "@/service/MenuRightService";
import HolidayService from "@/service/HolidayService";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import SweetAlertService from "@/service/SweetAlertService";
import StoreGetter from "@/constants/StoreGetter";
import { Holiday } from "@/model/Holiday";
import DatePicker from "vue2-datepicker";
import { datePickerLang } from "@/constants/globalConstants";
import Settings from "../../constants/Settings";
export default {
  components: { DatePicker },
  computed: {
    t() {
      return t;
    }
  },
  data() {
    return {
      EditH:false,
      YearType:[
        {
          value: "2025",
          label: 2025
        },
        {
          value: "2024",
          label: 2024
        },
        {
          value: "2023",
          label: 2023
        }
      ],
      menuRights: { allRights: {}, rightsForThisMenu: {} },
      menuId: Settings.MenuID.MM_Holiday,
      Settings: Settings,
      dictEnum: dictEnum,
      originTableData: [],
      tableData: [],
      selectedType: "",
      selectedYear:"",
      mode: "new",
      holiday: new Holiday(),
      lang: datePickerLang,
      currentPage: 1,
      tableFields: [
        {
          key: "DateHoliday",
          label: t.t(dictEnum.MENU_Holiday)
        },
        {
          key: "HolidayDesc",
          label: t.t(dictEnum.LBL_Description)
        },
        {
          key: "HolidayType",
          label: t.t(dictEnum.LBL_Type)
        },
        {
          key: "Action",
          label: t.t(dictEnum.BTN_Delete)
        }
      ]
    };
  },
  methods: {
    //取消编辑
    CancelHoliday(){
      this.EditH=false;
      this.getDataTable();
    },
    // 保存数据
   async SaveHoliday(){
      console.log(this.tableData,this.originTableData,'要保存的数据');
      console.log(this.selectedType,this.selectedYear,777);
      if(!this.selectedYear){
        SweetAlertService.warning("Warn", 'Please select a year.');
        return;
      }else if(!this.selectedType){
        SweetAlertService.warning("Warn", 'Please select the holidaytype.');
        return;
      }
      this.EditH=false;
     let Htable = this.originTableData.filter(
          item =>new Date(item.DateHoliday).getFullYear() == this.selectedYear
        );
        console.log(Htable,'数据');
      let obj={
        holidayType:this.selectedType,
        year:this.selectedYear,
        holidays:Htable
      }
      const response = await HolidayService.saveHoliday(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        this.getDataTable();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    //编辑状态
    EditHoliday(){
      this.EditH=true;
      this.selectedYear="";
      this.selectedType="";
    },
    hasRight(key) {
      if (Object.keys(this.menuRights.allRights).length === 0) {
        return false;
      } else {
        return MenuRightSerivce.hasRightInMenu(
          this.menuRights.allRights,
          this.menuId,
          key
        );
      }
    },
    assignRights() {
      this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];
      this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
        x => x.MenuID == this.menuId
      );
    },

    TypeName(data) {
      if (data) {
        if(data=='LABOR,BANK'){
          return t.t(dictEnum.LBL_HolidayTypeALL);
        }else{
          const find = Settings.HolidayType.find(x => x.value == data);
        if (find) {
          return find.label;
        }
        console.log(data,find,666);
        }
      }
    },

    initHoliday() {
      this.mode = "new";
      this.holiday = new Holiday();
    },
    async clickSyncfromGov() {
      this.selectedYear="";
      this.selectedType="";
      const response = await HolidayService.syncfromGov();
      if (response.data.IsSuccess) {
        // this.originTableData = response.data.Data;
        // this.tableData = response.data.Data;
        let syncfromData=response.data.Data;
        // 将原从政府获取的数据替换为最新从政府获取到的新数据
        const bMap = new Map(syncfromData.map(item => [item.DateHoliday, item]));
        let result = this.originTableData.map(item => bMap.has(item.DateHoliday) ? bMap.get(item.DateHoliday) : item);
        //将原数据中没有的最新政府数据加入到原数据内
        const aIds = new Set(this.originTableData.map(item => item.DateHoliday));
        result = this.originTableData.concat(syncfromData.filter(item => !aIds.has(item.DateHoliday)));
        this.originTableData = result;
        this.tableData = result;
        console.log(result,'同步数据');
        this.EditH=true;
        // SweetAlertService.success("Success", response.data.Message);
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    editHoliday(holiday) {
      this.mode = "edit";
      this.holiday = holiday;
    },
    async deleteHoliday(holiday) {
      if(this.EditH){
        this.originTableData = this.originTableData.filter(item => item.DateHoliday !== holiday.DateHoliday);
        this.tableData = this.tableData.filter(item => item.DateHoliday !== holiday.DateHoliday);
      }else{
        const sweetAlertOptions = {
        title: this.t.t(dictEnum.WARN_Confirm),
        text: `${t.t(dictEnum.WARN_DeleteHoliday)}`,
        cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
        confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
      };
      const result = await SweetAlertService.question(sweetAlertOptions);
      if (result.value) {
        const obj = {
          DateHoliday: moment(holiday.DateHoliday).format(
            Settings.DateTime.yyyymmdd
          ),
          HolidayDesc: holiday.HolidayDesc,
          UserId: this.$store.getters[StoreGetter.user].UserID
        };

        const response = await HolidayService.deleteHoliday(obj);
        if (response.data.IsSuccess) {
          SweetAlertService.success("Success", response.data.Message);
          this.getDataTable();
        } else {
          SweetAlertService.warning("Warn", response.data.Message);
        }
      }
      }
    },

    async editOrAddHoliday() {
      if (!this.holiday.DateHoliday) {
        SweetAlertService.warning(
          "Warn",
          t.t(dictEnum.MENU_Holiday) + t.t(dictEnum.WARN_IsRequired)
        );
        return;
      }

      if (!this.holiday.HolidayDesc) {
        SweetAlertService.warning(
          "Warn",
          t.t(dictEnum.LBL_Description) + t.t(dictEnum.WARN_IsRequired)
        );
        return;
      }

      if (!this.holiday.HolidayType) {
        SweetAlertService.warning(
          "Warn",
          t.t(dictEnum.LBL_Type) + t.t(dictEnum.WARN_IsRequired)
        );
      }
      this.holiday.DateHoliday = moment(this.holiday.DateHoliday).format(
        Settings.DateTime.yyyymmdd
      );

      const obj = {
        model: this.holiday
      };

      const response =
        this.mode === "new"
          ? await HolidayService.addHoliday(obj)
          : await HolidayService.updateHoliday(obj);

      if (response.data.IsSuccess) {
        this.holiday = new Holiday();
        SweetAlertService.success("Success", response.data.Message);
        this.getDataTable();
      } else {
        this.holiday = new Holiday();
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async getDataTable() {
      const obj = {};

      const response = await HolidayService.getHolidays(obj);

      if (response.data.IsSuccess) {
        this.originTableData = response.data.Data;
        this.tableData = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    handleTypeChange(...arg) {
      console.log(
        "arg---handleTypeChange",
        arg,
        "this.selectedType",
        this.selectedType,
        this.originTableData
      );
      if (!this.selectedType) {
        this.tableData = [...this.originTableData];
      } else {
        if(this.EditH){
          if(!this.selectedYear){
            SweetAlertService.warning("Warn", 'Please select a year.');
            this.selectedType="";
          }else{
            this.originTableData = this.originTableData.map(item => {
            if (new Date(item.DateHoliday).getFullYear() == this.selectedYear) {
              return { ...item, HolidayType: this.selectedType};
            }
            return item;
          });
          this.tableData = this.tableData.map(item => {
            if (new Date(item.DateHoliday).getFullYear() == this.selectedYear) {
              return { ...item, HolidayType: this.selectedType};
            }
            return item;
          });
          }
        }else{
          this.tableData = this.originTableData.filter(
          item =>!this.selectedYear? item.HolidayType == this.selectedType: new Date(item.DateHoliday).getFullYear() == this.selectedYear && item.HolidayType == this.selectedType
        );
        }
      }
    },
    
    handleYearChange(...arg) {
      console.log(
        "arg---handleTypeChange",
        arg,
        "this.selectedType",
        this.selectedYear,
        this.originTableData
      );
      if(this.EditH){
        this.selectedType="";
      }
      if (!this.selectedYear) {
        this.tableData = [...this.originTableData];
      } else {
        this.tableData = this.originTableData.filter(
          item =>!this.selectedType? new Date(item.DateHoliday).getFullYear() == this.selectedYear: new Date(item.DateHoliday).getFullYear() == this.selectedYear && item.HolidayType == this.selectedType
        );
      }
    }
  },
  
  mounted() {
    this.assignRights();
    this.getDataTable();
  }
};
</script>
<style scoped>
.input-group-text {
  background: white;
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/S050000-MM/S050500-Holiday.vue